import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { QuestionnaireList } from "@/components/cockpit/questionnaires/QuestionnaireList";
import { CockpitPageShell } from "@/components/cockpit/CockpitPageShell";
import { CockpitPageHeader } from "@/components/cockpit/CockpitPageHeader";
import { CockpitSkeletonCards } from "@/components/cockpit/CockpitSkeleton";

export const Route = createFileRoute("/_cockpit/cockpit/fragebogen/")({
  head: () => ({
    meta: [
      { title: "Fragebögen – Cockpit – creategy" },
      { name: "robots", content: "noindex, nofollow" },
      { name: "description", content: "Ihre zugewiesenen Fragebögen im Cockpit." },
    ],
  }),
  component: FragebogenPage,
});

function FragebogenPage() {
  return (
    <CockpitPageShell>
      <CockpitPageHeader
        title="Fragebögen"
        description="Ihre zugewiesenen Fragebögen. Eingaben werden automatisch zwischengespeichert – Sie können den Fragebogen jederzeit fortsetzen."
      />
      <Suspense fallback={<CockpitSkeletonCards />}>
        <QuestionnaireList />
      </Suspense>
    </CockpitPageShell>
  );
}
